import * as React from 'react';
import styles from './ColourKey.module.css';

export interface ColourKeyItem {
  id: string;
  label: string;
  bgColor: string;
}

export interface ColourKeyProps {
  items: ColourKeyItem[];
  title?: string;
  activeItems?: string[];
  updateActiveItems?: (activeItems: string[]) => void;
}

export const ColourKey = (props: ColourKeyProps): React.JSX.Element => {
  const handleItemClick = (item: ColourKeyItem) => {
    if (!props.updateActiveItems || !props.activeItems) return;
    if (props.activeItems.includes(item.id)) {
      props.updateActiveItems(props.activeItems.filter((i) => i !== item.id));
    } else {
      props.updateActiveItems([...props.activeItems, item.id]);
    }
  };

  const outerClasses = [styles.ColourKey];
  if (props.activeItems) {
    outerClasses.push(styles.Clickable);
  }

  return (
    <div className={outerClasses.join(' ')}>
      <h6>{props.title || 'Colour key'}</h6>
      <div>
        {props.items.map((item) => (
          <div
            key={item.id}
            className={!!props.activeItems && !props.activeItems.includes(item.id) ? styles.Inactive : ''}
            onClick={() => handleItemClick(item)}
          >
            <span
              style={{
                backgroundColor: item.bgColor,
              }}
            />
            <span>{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
